module.exports = __webpack_public_path__ + "assets/img/37_1606_big.e72eb33a.jpg";